import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TEstimatesTaxPaymentsTable = TEstimatesTaxPaymentsTableRow[];

export type TEstimatesTaxPaymentsTableRow = {
  year: Nullable<string>;
  datePaid: Nullable<string>;
  federalAmount: Nullable<string>;
  state: Nullable<string>;
  amount: Nullable<string>;
};

export interface TaxesPaidStateValues {
  didYouPayAnyUsTaxIsYear: Nullable<TYesOrNo>;
  pleaseUploadCorrespondingTaxFormw210991042SEtc: Nullable<string>;
  didYouMakeEstimatedTaxPaymentsToTheIrsOrAnyUsState: Nullable<string>;
  estimatesTaxPaymentsTable: TEstimatesTaxPaymentsTable;
  currency: Nullable<string>;
  didYouPayAnyNonUSTaxOnYourYearEarnings: Nullable<TYesOrNo>;
  didYouPayAnyNonUSTaxOnYourYearEarningsWhichYear: Nullable<TYesOrNo>;
  amountOfNonUSTaxPaidOnAnyEarningsWagesBonusSelfemploymentIncomeAndOtherPayment: Nullable<string>;
  didYouMakeContributionsToASocialSecuritySystemDuringYear: Nullable<TYesOrNo>;
  didYouMakeContributionsToASocialSecuritySystemDuringYearWhichYear: Nullable<TYesOrNo>;
  didYouMakeAnyEstimatedTaxPayments: Nullable<TYesOrNo>;
}

export interface TaxesPaidState {
  values: TaxesPaidStateValues;
}

const initialState: TaxesPaidState = {
  values: {
    didYouPayAnyUsTaxIsYear: null,
    pleaseUploadCorrespondingTaxFormw210991042SEtc: null,
    didYouMakeEstimatedTaxPaymentsToTheIrsOrAnyUsState: null,
    estimatesTaxPaymentsTable: [
      {
        year: null,
        datePaid: null,
        federalAmount: null,
        state: null,
        amount: null,
      },
    ],
    currency: null,
    didYouPayAnyNonUSTaxOnYourYearEarnings: null,
    didYouPayAnyNonUSTaxOnYourYearEarningsWhichYear: null,
    amountOfNonUSTaxPaidOnAnyEarningsWagesBonusSelfemploymentIncomeAndOtherPayment:
      null,
    didYouMakeContributionsToASocialSecuritySystemDuringYear: null,
    didYouMakeContributionsToASocialSecuritySystemDuringYearWhichYear: null,
    didYouMakeAnyEstimatedTaxPayments: null,
  },
};

const taxesPaidSlice = createSlice({
  name: 'taxesPaid',
  initialState,
  reducers: {
    update(state, action: PayloadAction<TaxesPaidStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof TaxesPaidStateValues | keyof TEstimatesTaxPaymentsTableRow;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof TaxesPaidStateValues | keyof TEstimatesTaxPaymentsTableRow;
        value: TEstimatesTaxPaymentsTable;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (action.payload.key === 'estimatesTaxPaymentsTable') {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.taxesDeductions
              .taxesPaid.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  taxesPaidSlice.actions;
export default taxesPaidSlice.reducer;

export const selectTaxesPaid = (state: RootState) =>
  state.taxQuestionnaire.taxesDeductions.taxesPaid;
